module.exports = __webpack_public_path__ + "static/media/crocodile(8).52812044.PNG";